import {
  MODAL_SHOW,
  MODAL_HIDE,
  MODAL_SERVER_ERROR_MESSAGE,
} from '../Actions/ResetPassword.action';
import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
  showPop: false,
  errors: {},
};
export const resetPasswordPopup = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MODAL_SHOW:
      return {
        ...state,
        ...action.payload,
        showPop: true,
      };
    case MODAL_HIDE:
      return {
        ...state,
        ...action.payload,
        showPop: false,
      };
    case MODAL_SERVER_ERROR_MESSAGE:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
